import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';

// Import design system
import './styles/index.css';

// ── PC pages ──
import Dashboard from './pages/Dashboard/Dashboard';
import Bills from './pages/Bills/Bills';
import Recharge from './pages/Recharge/Recharge';
import MyVideos from './pages/MyVideos/MyVideos';
import GenerateVideo from './pages/GenerateVideo/GenerateVideo';
import MyAvatars from './pages/MyAvatars/MyAvatars';
import VoiceUpload from './pages/VoiceCloning/VoiceUpload';
import MyVoices from './pages/VoiceCloning/MyVoices';
import ApiKeys from './pages/ApiKeys/ApiKeys';
import Invite from './pages/Invite/Invite';
import WorkflowResults from './pages/WorkflowResults/WorkflowResults';
import GenerateImage from './pages/GenerateImage/GenerateImage';
import MyImages from './pages/MyImages/MyImages';
import SubscriptionAdmin from './pages/SubscriptionAdmin/SubscriptionAdmin';

// ── Mobile pages ──
import MobileProtectedRoute from './mobile/components/MobileProtectedRoute';
import MobileLogin       from './mobile/pages/Login/MobileLogin';
import MobileHome        from './mobile/pages/Home/MobileHome';
import MobileGenerate    from './mobile/pages/Generate/MobileGenerate';
import MobileSelectAvatar from './mobile/pages/SelectAvatar/MobileSelectAvatar';
import MobileSelectVoice  from './mobile/pages/SelectVoice/MobileSelectVoice';
import MobileCreateAvatar from './mobile/pages/CreateAvatar/MobileCreateAvatar';
import MobileCreateVoice  from './mobile/pages/CreateVoice/MobileCreateVoice';
import MobileAvatars     from './mobile/pages/Avatars/MobileAvatars';
import MobileVoices      from './mobile/pages/Voices/MobileVoices';
import MobileTasks       from './mobile/pages/Tasks/MobileTasks';
import MobileTaskDetail  from './mobile/pages/TaskDetail/MobileTaskDetail';
import MobileBills       from './mobile/pages/Bills/MobileBills';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ── Mobile routes /m/* ── */}
          <Route path="/m/login" element={<MobileLogin />} />
          <Route path="/m" element={
            <MobileProtectedRoute><MobileHome /></MobileProtectedRoute>
          } />
          <Route path="/m/generate" element={
            <MobileProtectedRoute><MobileGenerate /></MobileProtectedRoute>
          } />
          <Route path="/m/select-avatar" element={
            <MobileProtectedRoute><MobileSelectAvatar /></MobileProtectedRoute>
          } />
          <Route path="/m/select-voice" element={
            <MobileProtectedRoute><MobileSelectVoice /></MobileProtectedRoute>
          } />
          <Route path="/m/create-avatar" element={
            <MobileProtectedRoute><MobileCreateAvatar /></MobileProtectedRoute>
          } />
          <Route path="/m/create-voice" element={
            <MobileProtectedRoute><MobileCreateVoice /></MobileProtectedRoute>
          } />
          <Route path="/m/avatars" element={
            <MobileProtectedRoute><MobileAvatars /></MobileProtectedRoute>
          } />
          <Route path="/m/voices" element={
            <MobileProtectedRoute><MobileVoices /></MobileProtectedRoute>
          } />
          <Route path="/m/tasks" element={
            <MobileProtectedRoute><MobileTasks /></MobileProtectedRoute>
          } />
          <Route path="/m/tasks/:id" element={
            <MobileProtectedRoute><MobileTaskDetail /></MobileProtectedRoute>
          } />
          <Route path="/m/bills" element={
            <MobileProtectedRoute><MobileBills /></MobileProtectedRoute>
          } />
          {/* Catch-all for /m/* */}
          <Route path="/m/*" element={<Navigate to="/m" replace />} />

          {/* ── PC routes (all wrapped in auth + layout) ── */}
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/bills" element={<Bills />} />
                  <Route path="/recharge" element={<Recharge />} />
                  <Route path="/my-videos" element={<MyVideos />} />
                  <Route path="/generate-video" element={<GenerateVideo />} />
                  <Route path="/my-avatars" element={<MyAvatars />} />
                  <Route path="/voice-cloning" element={<MyVoices />} />
                  <Route path="/api-keys" element={<ApiKeys />} />
                  <Route path="/workflow-results" element={<WorkflowResults />} />
                  <Route path="/invite" element={<Invite />} />
                  <Route path="/generate-image" element={<GenerateImage />} />
                  <Route path="/my-images" element={<MyImages />} />
                  <Route path="/subscription-admin" element={<SubscriptionAdmin />} />
                  {/* Catch all */}
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;